import { render, staticRenderFns } from "./AffairListItem.vue?vue&type=template&id=61dee058&"
import script from "./AffairListItem.vue?vue&type=script&lang=js&"
export * from "./AffairListItem.vue?vue&type=script&lang=js&"
import style0 from "./AffairListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports